import React, {useState,useRef} from 'react'
import {localestr} from '../utils'
import icon from '../icons.svg'
import Calc from '../cmp/Calc'
import MsgForm from '../cmp/msgForm'


function BreakCheck({orders,marks,value,setValue,setModal,setModal2}){
    const [val, setVal] = useState({first:null,second:null}) 
    //const [tasks, setTask] = useState(null) 
    const [anim, setAnim] = useState(0) 
    const targetRef = useRef()
    if(!orders) orders=[]

    const guest_bg=['linear-gradient(to top, #22C55E11, #22C55E66)',
                'linear-gradient(to top, #EAB30811, #EAB30866)',
                'linear-gradient(to top, #8B5CF611, #8B5CF666)',
                'linear-gradient(to top, #F9731611, #F9731666)',
                'linear-gradient(to top, #3B82F611, #3B82F666)',
                'linear-gradient(to top, #EC489911, #EC489966)',
    ]

    function msg(str,capt,actions){
        const modal2=<MsgForm Text={str} caption={capt} setModal={setModal2} actions={actions} id={'2'} />
        setModal2(modal2)
    }

    function modOrders(oper, data) {
        const newVal = { ...val };
        const initializeOrder = (target) => {
            if (!newVal[target]) {
                newVal[target] = orders.find(el => (String(el.uid) === String(value.uid) && String(el.id) === String(value.id)) || (String(el.uid) === String(value.uid) || String(el.id) === value.id));
                if (!newVal[target]) return false;
                newVal[target] = { ...newVal[target] };
                newVal[target].docTable = newVal[target].docTable.map(el => ({ ...el }));
                if (value.uid) newVal[target].uid = value.uid;
                if (value.id) newVal[target].id = value.id;
                return true;
            }
            return true;
        };
    
        const initializeSecondOrder = () => {
            if (!newVal.second) {
                newVal.second = { ...newVal.first };
                newVal.second.id = null;
                newVal.second.uid = null;
                newVal.second.guests = 1;
                newVal.second.curent = 0;
                newVal.second.docTable = [];
            }
        };
    
        const calculateAmount = (item, discountObj) => {
            let price_delta=0
            if(item.modifiers) item.modifiers.forEach(el=>price_delta+=parseFloat(el.price)||0)
            const price = (parseFloat(item.menu.price) || 0)+price_delta
            let disc = discountObj?.prc || 0;
            let disc_mode = discountObj?.mode || 0;
            let newAmount = item.qtt * price * (100 - disc) / 100;
    
            if (item.menu.disable_discount) {
                newAmount = item.qtt * price;
                item.discount = null;
            } else if (disc && !disc_mode) {
                item.discount = (item.qtt * price * disc / 100).toFixed(2);
            } else {
                item.discount = null;
            }
            item.amount = newAmount.toFixed(2);
        };

        const calculateMarks = (item,old_qtt,new_qtt) => {
            if(item.mark1) {
                let per_unit=parseFloat(item.menu.koef||1)*parseFloat(item.menu.ex_good1.qtt||0)*10000
                const is_liter=item.menu.ex_good1.unit===3?1:0
                let need_qtt=(new_qtt)*per_unit
                if(is_liter&&old_qtt) need_qtt=(new_qtt||0)*parseInt(item.qtt1||0)/parseFloat(old_qtt||1) //Приблизно
                const idx_=marks.findIndex(el=>el.code===item.mark1)
                if(idx_!==-1){
                    if(is_liter) need_qtt=(new_qtt||0)*per_unit*1000/marks[idx_].vol //Точно
                }
                item.qtt1=need_qtt
            }
            if(item.mark2) {
                let per_unit=parseFloat(item.menu.koef||1)*parseFloat(item.menu.ex_good2.qtt||0)*10000
                const is_liter=item.menu.ex_good2.unit===3?1:0
                let need_qtt=(new_qtt)*per_unit
                if(is_liter&&old_qtt) need_qtt=(new_qtt||0)*parseInt(item.qtt2||0)/parseFloat(old_qtt||1) //Приблизно
                const idx_=marks.findIndex(el=>el.code===item.mark2)
                if(idx_!==-1){
                    if(is_liter) need_qtt=(new_qtt||0)*per_unit*1000/marks[idx_].vol //Точно
                }
                item.qtt2=need_qtt
            }
            if(item.mark3) {
                let per_unit=parseFloat(item.menu.koef||1)*parseFloat(item.menu.ex_good3.qtt||0)*10000
                const is_liter=item.menu.ex_good3.unit===3?1:0
                let need_qtt=(new_qtt)*per_unit
                if(is_liter&&old_qtt) need_qtt=(new_qtt||0)*parseInt(item.qtt3||0)/parseFloat(old_qtt||1) //Приблизно
                const idx_=marks.findIndex(el=>el.code===item.mark3)
                if(idx_!==-1){
                    if(is_liter) need_qtt=(new_qtt||0)*per_unit*1000/marks[idx_].vol //Точно
                }
                item.qtt3=need_qtt
            }
            if(item.mark4) {
                let per_unit=parseFloat(item.menu.koef||1)*parseFloat(item.menu.ex_good4.qtt||0)*10000
                const is_liter=item.menu.ex_good4.unit===3?1:0
                let need_qtt=(new_qtt)*per_unit
                if(is_liter&&old_qtt) need_qtt=(new_qtt||0)*parseInt(item.qtt4||0)/parseFloat(old_qtt||1) //Приблизно
                const idx_=marks.findIndex(el=>el.code===item.mark4)
                if(idx_!==-1){
                    if(is_liter) need_qtt=(new_qtt||0)*per_unit*1000/marks[idx_].vol //Точно
                }
                item.qtt4=need_qtt
            }
            if(item.mark5) {
                let per_unit=parseFloat(item.menu.koef||1)*parseFloat(item.menu.ex_good5.qtt||0)*10000
                const is_liter=item.menu.ex_good5.unit===3?1:0
                let need_qtt=(new_qtt)*per_unit
                if(is_liter&&old_qtt) need_qtt=(new_qtt||0)*parseInt(item.qtt5||0)/parseFloat(old_qtt||1) //Приблизно
                const idx_=marks.findIndex(el=>el.code===item.mark5)
                if(idx_!==-1){
                    if(is_liter) need_qtt=(new_qtt||0)*per_unit*1000/marks[idx_].vol //Точно
                }
                item.qtt5=need_qtt
            }
        }
    
        const findMatchingIndex = (table, item) => {
            return table.findIndex(el =>
                el.menu.id === item.menu.id &&
                el.status === item.status &&
                el.refuse === item.refuse &&
                el.mark1 === item.mark1 &&
                el.mark2 === item.mark2 &&
                el.mark3 === item.mark3 &&
                el.mark4 === item.mark4 &&
                el.mark5 === item.mark5 &&
                el.nom === item.nom &&
                el.guest === item.guest &&
                JSON.stringify(el.modifiers || '') === JSON.stringify(item.modifiers || '')
            );
        };
    
        const transferItem = (sourceTable, targetTable, sourceIndex, targetKey, quantity) => {
            if (sourceIndex === null || sourceIndex === undefined || sourceTable.length <= sourceIndex) return;
            const source = sourceTable[sourceIndex];
            const targetItem = { ...source };
            const remainingQty = Math.round((parseFloat(source.qtt) - quantity)*1000)/1000;
    
            if (remainingQty <= 0) {
                sourceTable.splice(sourceIndex, 1);
                if (newVal[targetKey].curent > sourceTable.length - 1) {
                    newVal[targetKey].curent = sourceTable.length - 1;
                }
                targetItem.qtt = source.qtt;
            } else {
                source.qtt = remainingQty;
                targetItem.qtt = quantity;
                calculateAmount(source, newVal[targetKey].discount);
                calculateMarks(source,parseFloat(source.qtt)||0,remainingQty)
                calculateMarks(targetItem,parseFloat(source.qtt)||0,quantity)
            }
    
            const targetIndex = findMatchingIndex(targetTable, targetItem);
            if (targetIndex === -1) {
                calculateAmount(targetItem, newVal.second.discount);
                targetItem.need_focus=true
                targetTable.push(targetItem)
                targetTable.sort((a,b)=>{
                    if(a.guest>b.guest)  return 1
                    if(a.guest<b.guest)  return -1
                    if(a.nom>b.nom)  return 1
                    if(a.nom<b.nom)  return -1
                    if(a.uid>b.uid)  return 1
                    if(a.uid<b.uid)  return -1
                    return 0
                })
                const new_curent = targetTable.findIndex(el=>el.need_focus)
                if(new_curent!==-1) delete targetTable[new_curent].need_focus
                if(targetKey==='second') newVal.first.curent=new_curent
                else newVal.second.curent=new_curent
            } else {
                targetTable[targetIndex].qtt = (parseFloat(targetTable[targetIndex].qtt) + parseFloat(targetItem.qtt)).toFixed(3);
                targetTable[targetIndex].qtt1 = String(parseInt(targetTable[targetIndex].qtt1||0) + parseInt(targetItem.qtt1||0));
                targetTable[targetIndex].qtt2 = String(parseInt(targetTable[targetIndex].qtt2||0) + parseInt(targetItem.qtt2||0));
                targetTable[targetIndex].qtt3 = String(parseInt(targetTable[targetIndex].qtt3||0) + parseInt(targetItem.qtt3||0));
                targetTable[targetIndex].qtt4 = String(parseInt(targetTable[targetIndex].qtt4||0) + parseInt(targetItem.qtt4||0));
                targetTable[targetIndex].qtt5 = String(parseInt(targetTable[targetIndex].qtt5||0) + parseInt(targetItem.qtt5||0));
                calculateAmount(targetTable[targetIndex], newVal.second.discount);
                //newVal.second.curent = targetIndex;
                if(targetKey==='second') newVal.first.curent=targetIndex
                else newVal.second.curent=targetIndex
            }
        }

        const transferGuest = (sourceTable, targetTable, guest) => {
            if (!guest) return
            for(let i=0;i<sourceTable.length;i++){
                if(sourceTable[i].guest!==guest) continue
                const targetItem = { ...sourceTable[i]}
                sourceTable[i].del=true
                sourceTable.splice(i, 1)
                i--
                const targetIndex = findMatchingIndex(targetTable, targetItem);
                if (targetIndex === -1) {
                    calculateAmount(targetItem, newVal.second.discount);
                    targetTable.push(targetItem)
                } else {
                    targetTable[targetIndex].qtt = (parseFloat(targetTable[targetIndex].qtt) + parseFloat(targetItem.qtt)).toFixed(3);
                    targetTable[targetIndex].qtt1 = String(parseInt(targetTable[targetIndex].qtt1||0) + parseInt(targetItem.qtt1||0));
                    targetTable[targetIndex].qtt2 = String(parseInt(targetTable[targetIndex].qtt2||0) + parseInt(targetItem.qtt2||0));
                    targetTable[targetIndex].qtt3 = String(parseInt(targetTable[targetIndex].qtt3||0) + parseInt(targetItem.qtt3||0));
                    targetTable[targetIndex].qtt4 = String(parseInt(targetTable[targetIndex].qtt4||0) + parseInt(targetItem.qtt4||0));
                    targetTable[targetIndex].qtt5 = String(parseInt(targetTable[targetIndex].qtt5||0) + parseInt(targetItem.qtt5||0));
                    calculateAmount(targetTable[targetIndex], newVal.second.discount);
                }
            }
            targetTable.sort((a,b)=>{
                if(a.guest>b.guest)  return 1
                if(a.guest<b.guest)  return -1
                if(a.nom>b.nom)  return 1
                if(a.nom<b.nom)  return -1
                if(a.uid>b.uid)  return 1
                if(a.uid<b.uid)  return -1
                return 0
            })
            newVal.first.curent=-1
            newVal.second.curent=-1
        }

        const calcGuests=(docTable)=>{
            let g=0
            let cnt=0
            for(let i=0;i<docTable.length;i++){
                if(g!==docTable[i].guest){
                    g=docTable[i].guest
                    cnt++
                }
            }
            return cnt
        }
    
        if (oper === 'first_cur' || oper === 'second_cur') {
            const target = oper === 'first_cur' ? 'first' : 'second';
            if (!initializeOrder(target)) return;
            if (target === 'second' && !newVal.second.docTable) {
                newVal.second.id = null;
                newVal.second.uid = null;
                newVal.second.curent = 0;
                newVal.second.docTable = [];
            }
            newVal[target].curent = data;
            setVal(newVal);
        }
        else if (oper === 'first_one' || oper === 'first_all' || oper === 'first_calc') {
            if (!initializeOrder('first')) return;
            if (newVal.first.curent === null || newVal.first.curent === undefined) return;
            initializeSecondOrder();
    
            const docTable1 = [...newVal.first.docTable];
            const docTable2 = [...newVal.second.docTable];
            if(!docTable1.length) return
    
            if (oper === 'first_calc' && !data) {
                setModal2(<Calc value={1} setValue={(val) => { modOrders(oper, val) }} setModal={setModal2} />);
                return;
            }
    
            const quantity = oper === 'first_one' ? 1 :
                oper === 'first_all' ? parseFloat(docTable1[newVal.first.curent].qtt) :
                    Math.min(parseFloat(data), parseFloat(docTable1[newVal.first.curent].qtt));
    
            if (quantity <= 0) return;
    
            transferItem(docTable1, docTable2, newVal.first.curent, 'first', quantity);
    
            newVal.first.docTable = docTable1;
            newVal.second.docTable = docTable2;
            setVal(newVal);
        }
        else if (oper === 'first_quest') {
            if (!initializeOrder('first')) return
            msg(localestr('Перенести всі позиції гостя?'),'',[{caption:localestr('Так'),action:()=>{modOrders('first_guest', data)}},{caption:localestr('Ні'),action:()=>{}}])
            return
        }
        else if (oper === 'first_guest') {
            if (!initializeOrder('first')) return
            initializeSecondOrder()
    
            const docTable1 = [...newVal.first.docTable]
            const docTable2 = [...newVal.second.docTable]

            const guest=parseInt(data)
            transferGuest(docTable1, docTable2,guest)
    
            newVal.first.docTable = docTable1
            newVal.first.guests = calcGuests(docTable1)
            newVal.second.docTable = docTable2;
            newVal.second.guests = calcGuests(docTable2)
            setVal(newVal);
        }
       
        else if (oper === 'second_one' || oper === 'second_all') {
            if (!initializeOrder('first')) return;
            if (newVal.second.curent === null || newVal.second.curent === undefined) return;
            initializeSecondOrder();
    
            const docTable1 = [...newVal.first.docTable];
            const docTable2 = [...newVal.second.docTable];
            if(!docTable2.length) return
    
            const quantity = oper === 'second_one' ? 1 : parseFloat(docTable2[newVal.second.curent].qtt);
    
            transferItem(docTable2, docTable1, newVal.second.curent, 'second', quantity);
    
            newVal.first.docTable = docTable1;
            newVal.second.docTable = docTable2;
            setVal(newVal);
        }
        else if (oper === 'second_quest') {
            if (!initializeOrder('first')) return
            msg(localestr('Перенести всі позиції гостя?'),'',[{caption:localestr('Так'),action:()=>{modOrders('second_guest', data)}},{caption:localestr('Ні'),action:()=>{}}])
            return
        }
        else if (oper === 'second_guest') {
            if (!initializeOrder('first')) return
            initializeSecondOrder()
    
            const docTable1 = [...newVal.first.docTable]
            const docTable2 = [...newVal.second.docTable]

            const guest=parseInt(data)
            transferGuest(docTable2, docTable1,guest)
    
            newVal.first.docTable = docTable1
            newVal.first.guests = calcGuests(docTable1)
            newVal.second.docTable = docTable2;
            newVal.second.guests = calcGuests(docTable2)
            setVal(newVal);
        }
        else if (oper === 'second_order') {
            if (newVal.second && (newVal.second.uid === data || newVal.second.id === data)) return;
            newVal.first = null;
            newVal.second = orders.find(el => (String(el.uid) === String(data) && String(el.id) === String(data)) || (String(el.uid) === String(data) || String(el.id) === String(data)));
            if (newVal.second) {
                newVal.second = { ...newVal.second };
                newVal.second.docTable = newVal.second.docTable.map(el => ({ ...el }));
                newVal.second.curent = 0;
            }
            setVal(newVal);
        }
        setAnim(1);
    }

    function getClass(curent,idx,status,refuse){
        let plus=''
        if(curent===idx) plus='selected '
        if(refuse&&parseInt(refuse)) return plus+'refuse'
        if(parseInt(status)>4) return plus+'pay'
        if(parseInt(status)>3) return plus+'refuse'
        if(parseInt(status)>2) return plus+'done'
        if(parseInt(status)>1) return plus+'process'
        return plus
    }

    function setVisible(el){
        if (!el) return
        const rect = el.getBoundingClientRect()
        const p_rect=el.parentNode.getBoundingClientRect()
        if(rect.top+p_rect.height<p_rect.top+p_rect.height&&rect.top>=p_rect.top) return
        //якщо треба покрутити
        //if(Anim) el.scrollIntoView({behavior:'smooth'})
        if(anim===1) el.scrollIntoView({behavior:'smooth'})
        else if(anim===0) el.scrollIntoView()
        setAnim(-1)
        //setAnim(true)
   }

    function fillOrder(order,num){
        let tbl=[]
        let sumTotal=0
        const curent=order?order.curent:0||0
        if(order&&order.docTable) tbl=order.docTable.sort((a,b)=>{
            if(a.guest>b.guest)  return 1
            if(a.guest<b.guest)  return -1
            if(a.nom>b.nom)  return 1
            if(a.nom<b.nom)  return -1
            if(a.uid>b.uid)  return 1
            if(a.uid<b.uid)  return -1
            return 0
        })
        let guest=0
        const tblitems=[]
        for(let i=0;i<tbl.length;i++){
            const el={name:tbl[i].menu?tbl[i].menu.name:tbl[i].menu_name,...tbl[i],qtt:parseFloat(tbl[i].qtt)}
            if(el.act==='del') continue
            if(!el.refuse) sumTotal+=parseFloat(el.amount||0)
            const ex_mark1=el.mark1?((el.excise_mark||'').indexOf(el.mark1,0)!==-1?<span style={{fontStyle:'italic',fontSize:'small',color:'blue'}}>{' '+el.mark1}</span>:<span style={{fontStyle:'italic',fontSize:'small',color:'var(--dark-tx-color)'}}>{' ('+el.mark1+')'}</span>):null
            const ex_mark2=el.mark2?((el.excise_mark||'').indexOf(el.mark2,0)!==-1?<span style={{fontStyle:'italic',fontSize:'small',color:'blue'}}>{' '+el.mark2}</span>:<span style={{fontStyle:'italic',fontSize:'small',color:'var(--dark-tx-color)'}}>{' ('+el.mark2+')'}</span>):null
            const ex_mark3=el.mark3?((el.excise_mark||'').indexOf(el.mark3,0)!==-1?<span style={{fontStyle:'italic',fontSize:'small',color:'blue'}}>{' '+el.mark3}</span>:<span style={{fontStyle:'italic',fontSize:'small',color:'var(--dark-tx-color)'}}>{' ('+el.mark3+')'}</span>):null
            const ex_mark4=el.mark4?((el.excise_mark||'').indexOf(el.mark4,0)!==-1?<span style={{fontStyle:'italic',fontSize:'small',color:'blue'}}>{' '+el.mark4}</span>:<span style={{fontStyle:'italic',fontSize:'small',color:'var(--dark-tx-color)'}}>{' ('+el.mark4+')'}</span>):null
            const ex_mark5=el.mark5?((el.excise_mark||'').indexOf(el.mark5,0)!==-1?<span style={{fontStyle:'italic',fontSize:'small',color:'blue'}}>{' '+el.mark5}</span>:<span style={{fontStyle:'italic',fontSize:'small',color:'var(--dark-tx-color)'}}>{' ('+el.mark5+')'}</span>):null

            if(order.guests>1 && el.guest!==guest) {
                guest=el.guest
                tblitems.push(<tr key={num+'g'+guest} className='tbl_guest'><td colSpan={6} onClick={()=>{modOrders(num+'_quest',el.guest)}} style={{height:'26px',paddingTop:'6px',cursor:'pointer',background:guest_bg[(guest-1)%guest_bg.length]}}>
                <div style={{maskImage:'url('+icon+'#btn23)',WebkitMaskImage:'url('+icon+'#btn23)',margin:'1px 5px -1px 2px',backgroundColor:'var(--black-tx-color)',width:'14px',height:'14px',display:'inline-block'}}></div>{localestr('ГІСТЬ ')+guest}</td></tr>)
            }

            if(i===curent) tblitems.push(<tr key={i} ref={el=>{setVisible(el);return targetRef}} tabIndex='0' className={getClass(curent,i,el.status,el.refuse)} onClick={()=>{}}><td>{el.name+(el.comment?' '+el.comment:'')}{ex_mark1}{ex_mark2}{ex_mark3}{ex_mark4}{ex_mark5}</td><td style={{width:'58px',minWidth:'58px'}}>{el.qtt}</td><td style={{width:'58px',minWidth:'58px'}}>{el.amount}</td></tr>)
            else tblitems.push(<tr key={i} tabIndex='0' className={getClass(curent,i,el.status,el.refuse)} onClick={()=>{modOrders(num+'_cur',i)}}><td>{el.name+(el.comment?' '+el.comment:'')}{ex_mark1}{ex_mark2}{ex_mark3}{ex_mark4}{ex_mark5}</td><td style={{width:'58px',minWidth:'58px'}}>{el.qtt}</td><td style={{width:'58px',minWidth:'58px'}}>{el.amount}</td></tr>)

        }
        //console.log(tbl)

        let capt=localestr('Нове замовлення')
        if(order) capt=(order.table?.name||order.address||'')+' '+(order.table?.owner?.name||'')+' '+(order.id?'№'+order.id:'*')
        if (capt.length>30) capt=capt.substring(0,27)+'...'
        if(num==='second'){
            capt=localestr('Нове замовлення')
            let sel_val=''
            let sel_opts=orders.map((el,idx)=>{
                if(value&&el.uid===value.uid) return null
                else if(order&&el.uid===order.uid) {sel_val=el.uid; return <option key={idx} value={el.uid}>{(el.table?.name||el.phone||'')+' '+(el.table?.owner?.name||el.name||'')+' '+(el.id?'№'+el.id:'*')}</option>}
                //else if(el.docType) return <option key={idx} value={el.uid}>{el.phone+' '+localestr('доставка')+' '+(el.id?'№'+el.id:'*')}</option>
                else return <option key={idx} value={el.uid}>{(el.table?.name||el.phone||'')+' '+(el.table?.owner?.name||el.name||'')+' '+(el.id?'№'+el.id:'*')}</option>
            })
            if(!order) {sel_val=''; sel_opts.push(<option key={orders.length} value={''}>{capt}</option>)}
            else if(!order.uid) {sel_val=''; sel_opts.push(<option key={orders.length} value={''}>{capt}</option>)}
            else sel_opts.push(<option key={orders.length} value={''}>{capt}</option>)
            capt=<select style={{fontSize:'large',fontWeight:'bold',maxWidth:'260px'}} value={sel_val} onChange={(e)=>modOrders(num+'_order',e.target.value||null)}>{sel_opts}</select>
        }

        const ttl=' '+sumTotal.toFixed(2)+' '
        const stl={display:'flex',height:'260px'}
        if(img==='h'&&window.innerHeight>450) stl.height='320px'
        if(img==='h'&&window.innerHeight>550) stl.height='420px'
    
        return(
            <div style={{flexGrow:'200',flexBasis:'200px',minWidth:'340px',maxWidth:'360px'}}>
                <div style={{height:'28px',display:'flex',fontSize:'large',fontWeight:'bold'}}><div style={{flexGrow:'1',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}}>{capt}</div><div>{ttl}</div></div>
                <div style={stl} className={'ord_table'}>
                <table><thead><tr><th>{localestr('Назва')}</th><th style={{width:'65px',minWidth:'65px'}}>{localestr('К-сть')}</th><th>{localestr('Сума')}</th></tr></thead><tbody>{tblitems}</tbody></table>
            </div></div>
        )
    }

    const ord1=val.first||orders.find(el=>el.uid===value.uid)
    const ord2=val.second

    const stl0={display:'flex',height:'100%'}
    const stl1={display:'flex',flexWrap:'nowrap', justifyContent:'center'}
    let img='h'
    if(window.innerWidth<=window.innerHeight) {
        stl0.flexDirection='column'
        stl1.flexDirection='row'
        img='v'
    }
    else {
        stl0.flexDirection='row'
        stl1.flexDirection='column'
        stl1.paddingTop='28px'
    }

    return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Розбити чек')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'><div style={stl0}>
            {fillOrder(ord1,'first')}
            <div style={stl1}>
            <div className='ord_button toolBarItem' title={localestr('Перемістити 1')} onClick={()=>{modOrders('first_one')}}><img src={icon+'#btn18'+img} alt='' /></div>
            <div className='ord_button toolBarItem' title={localestr('Перемістити позицію')} onClick={()=>{modOrders('first_all')}}><img src={icon+'#btn19'+img} alt='' /></div>
            <div className='ord_button toolBarItem' title={localestr('Ввести кількість')} onClick={()=>{modOrders('first_calc')}}><img src={icon+'#btn3'} alt='' /></div>
            <div className='ord_button' style={{background:'none'}}></div>
            <div className='ord_button toolBarItem' title={localestr('Перемістити 1')} onClick={()=>{modOrders('second_one')}}><img src={icon+'#btn20'+img} alt='' /></div>
            <div className='ord_button toolBarItem' title={localestr('Перемістити позицію')} onClick={()=>{modOrders('second_all')}}><img src={icon+'#btn21'+img} alt='' /></div>
            </div>
            {fillOrder(ord2,'second')}
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={{width:'120px',margin:'0',borderRadius:'20px'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>{setValue(val);setModal('')}}><div>OK</div></div>
                    <div style={{width:'120px',margin:'0 0 0 24px',borderRadius:'20px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div>{localestr('Відмінити')}</div></div>
                </div>
            </div></div>
        </div></div>
    )
}

export default BreakCheck